import { createSlice } from '@reduxjs/toolkit'

// import { FALSE } from 'sass'
const slice = createSlice({
  name: 'Other Service',
  initialState: {
    productList: [],
    productListLoading: false,
    productListPaginationData: {},
    productListDetails: [],
    productListDetailsLoading: false,
    modalOpen: false,
    getProductDetails: {},
    storesProductExcelLoading: false,
    updateStoreProductApi: false,

    // admin Product
    adminProductListLoading: false,
    adminProductList: [],
    adminProductListPaginationData: {},
    adminProductListDetailsLoading: false,
    getAdminProductDetails: {},
    updateAdminProductApi: false,

    excelError: [],
    ApiError: '',
  },
  reducers: {
    getStoreProductListApiData: (state, { payload }) => {
      state.productListLoading = true
    },
    getStoreProductListApiSuccess: (state, { payload }) => {
      state.productListLoading = false
      state.productList = payload?.payload?.data
      state.productListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStoreProductListApiFailed: (state, { payload }) => {
      state.productListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // details Store type
    getStoreProductDetailsListApiData: (state, { payload }) => {
      state.productListDetailsLoading = true
    },
    getStoreProductDetailsListApiSuccess: (state, { payload }) => {
      state.getProductDetails = payload?.payload?.data
      state.productListDetailsLoading = false
    },
    getStoreProductDetailsListApiFailed: (state, { payload }) => {
      state.productListDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // add Product
    addStoreProductListApiData: (state, { payload }) => {
      state.productListLoading = true
      state.updateStoreProductApi = false
      state.modalOpen = false
      state.ApiError = ''
    },
    addStoreProductListApiSuccess: (state, { payload }) => {
      state.updateStoreProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.productListLoading = false
    },
    addStoreProductListApiFailed: (state, { payload }) => {
      state.productListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Update Product
    updateStoreProductListApiData: (state, { payload }) => {
      state.updateStoreProductApi = false
      state.productList = state.productList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateStoreProductListApiSuccess: (state, { payload }) => {
      state.updateStoreProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStoreProductListApiFailed: (state, { payload }) => {
      state.updateStoreProductApi = false
      alert(JSON.stringify(payload, null, 2))
    },
    // delete Product
    deleteStoreProductListItemApiData: (state, { payload }) => {
      let updatedStoreProductList = state.productList?.filter((item) => item.id !== payload?.id)
      state.productList = updatedStoreProductList
      state.updateStoreProductApi = false
    },
    deleteStoreProductListItemApiSuccess: (state, { payload }) => {
      state.updateStoreProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStoreProductListItemApiFailed: (state, { payload }) => {
      state.updateStoreProductApi = false
      alert(JSON.stringify(payload, null, 2))
    },
    // product Status Change
    productStatusChangeApiData: (state, { payload }) => {
      state.updateStoreProductApi = false
      state.productListLoading = true
    },
    productStatusChangeApiSuccess: (state, { payload }) => {
      state.updateStoreProductApi = true
      state.productListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    productStatusChangeApiFailed: (state, { payload }) => {
      state.updateStoreProductApi = false
      state.productListLoading = false
    },
    // get Admin product Api
    getAdminProductListApiData: (state, { payload }) => {
      state.adminProductListLoading = true
    },
    getAdminProductListApiSuccess: (state, { payload }) => {
      state.adminProductListLoading = false
      state.adminProductList = payload?.payload?.data
      state.adminProductListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getAdminProductListApiFailed: (state, { payload }) => {
      state.adminProductListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Get Admin product details
    getAdminProductDetailsListApiData: (state, { payload }) => {
      state.adminProductListDetailsLoading = true
    },
    getAdminProductDetailsListApiSuccess: (state, { payload }) => {
      state.getAdminProductDetails = payload?.payload?.data
      state.adminProductListDetailsLoading = false
    },
    getAdminProductDetailsListApiFailed: (state, { payload }) => {
      state.adminProductListDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Admin Product
    addAdminProductListApiData: (state, { payload }) => {
      state.adminProductListLoading = true
      state.updateAdminProductApi = false
      state.modalOpen = false
      state.ApiError = ''
    },
    addAdminProductListApiSuccess: (state, { payload }) => {
      state.updateAdminProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.adminProductListLoading = false
    },
    addAdminProductListApiFailed: (state, { payload }) => {
      state.adminProductListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Admin Product List
    updateAdminProductListApiData: (state, { payload }) => {
      state.updateAdminProductApi = false
      state.adminProductList = state.adminProductList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateAdminProductListApiSuccess: (state, { payload }) => {
      state.updateAdminProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateAdminProductListApiFailed: (state, { payload }) => {
      state.updateAdminProductApi = false
      alert(JSON.stringify(payload, null, 2))
    },

    deleteAdminProductListItemApiData: (state, { payload }) => {
      let updatedAdminProductList = state.adminProductList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.adminProductList = updatedAdminProductList
      state.updateAdminProductApi = false
    },
    deleteAdminProductListItemApiFailed: (state, { payload }) => {
      state.updateAdminProductApi = false
      alert(JSON.stringify(payload, null, 2))
    },
    deleteAdminProductListItemApiSuccess: (state, { payload }) => {
      state.updateAdminProductApi = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    // Admin product Status Change
    adminProductStatusChangeApiData: (state, { payload }) => {
      state.updateAdminProductApi = false
      state.adminProductListLoading = true
    },
    adminProductStatusChangeApiSuccess: (state, { payload }) => {
      state.updateAdminProductApi = true
      state.adminProductListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    adminProductStatusChangeApiFailed: (state, { payload }) => {
      state.updateAdminProductApi = false
      state.adminProductListLoading = false
    },

    // add Product By Excel
    addBulkProductByExcelApiData: (state, { payload }) => {
      state.storesProductExcelLoading = true
      state.modalOpen = false
    },
    addBulkProductByExcelApiSuccess: (state, { payload }) => {
      // state.pharmacyExcelLoading
      state.storesProductExcelLoading = false
      state.modalOpen = true
      state.excelError = payload?.payload || []
    },

    addBulkProductByExcelApiFailed: (state, { payload }) => {
      state.storesProductExcelLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    resetOtherServiceError: (state, { payload }) => {
      state.modalOpen = false
      state.excelError = []
      state.ApiError = ''
    },
  },
})

export const {
  // Store Product List
  getStoreProductListApiData,
  getStoreProductListApiSuccess,
  getStoreProductListApiFailed,
  // Store Product Item Details
  getStoreProductDetailsListApiData,
  getStoreProductDetailsListApiSuccess,
  getStoreProductDetailsListApiFailed,

  // add Product
  addStoreProductListApiData,
  addStoreProductListApiSuccess,
  addStoreProductListApiFailed,
  // Update Product
  updateStoreProductListApiData,
  updateStoreProductListApiSuccess,
  updateStoreProductListApiFailed,
  // delete Product
  deleteStoreProductListItemApiData,
  deleteStoreProductListItemApiSuccess,
  deleteStoreProductListItemApiFailed,
  // product Status Change
  productStatusChangeApiData,
  productStatusChangeApiSuccess,
  productStatusChangeApiFailed,
  // Add Bulk Product
  addBulkProductByExcelApiData,
  addBulkProductByExcelApiSuccess,
  addBulkProductByExcelApiFailed,

  // get Admin product Api
  getAdminProductListApiData,
  getAdminProductListApiSuccess,
  getAdminProductListApiFailed,

  // Get Admin product details
  getAdminProductDetailsListApiData,
  getAdminProductDetailsListApiSuccess,
  getAdminProductDetailsListApiFailed,

  // Add Admin Product
  addAdminProductListApiData,
  addAdminProductListApiSuccess,
  addAdminProductListApiFailed,

  // Update Admin Product List
  updateAdminProductListApiData,
  updateAdminProductListApiSuccess,
  updateAdminProductListApiFailed,
  //Delete Admin Product List
  deleteAdminProductListItemApiData,
  deleteAdminProductListItemApiSuccess,
  deleteAdminProductListItemApiFailed,
  // Admin product Status Change
  adminProductStatusChangeApiData,
  adminProductStatusChangeApiSuccess,
  adminProductStatusChangeApiFailed,
  // Reset Error
  resetOtherServiceError,
} = slice.actions

export default slice.reducer
